import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';

import { HBox, VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { List, Row } from '../../../components/List';
import { Check, Edit, Trash, CircleTimes } from '../../../components/Icon';
import { Calendar } from '../../../components/Icon';
import { deleteVehicleProperty, setVehicleProperty } from '../actions';
import { selectWorks } from '../../Api/selectors';
import { getPropByName } from '../../../utils/props';
import { REQUEST_USER } from '../../Users/constants';
import { REQUEST_VEHICLE_PROPERTY_DELETE, REQUEST_VEHICLE_PROPERTY_UPDATE } from '../constants';
import { selectUser } from '../../Users/selectors';
import { fetchUser } from '../../Users/actions';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import LoadingDetailsPageCard from '../../../containers/App/Components/LoadingDetailsPageCard/LoadingDetailsPageCard';
import cn from 'classnames';
import styles from './CardVehicleTestDrive.module.css';
import { Textarea } from '../../../components/Textarea';

dayjs.extend(customParseFormat);
const Container = styled.div`
  font-size: 14px;

  .icon-block {
    cursor: pointer;
    font-size: 22px;
  }

  .icon-cross {
    cursor: pointer;
    font-size: 18px;
    width: 20px;
    height: 22px;
  }

  .icon-edit-square {
    color: #0183D5;
  }

  .fa-square-xmark {
    padding: 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;

    background-color: #d50046;
    color: #fff;
  }

  align-items: center;

  .remark {
    margin-bottom: 10px;
    min-height: 60px;

    .initials-wrapper {
      width: 40px;
      height: 40px;
      background-color: rgba(29, 155, 209, 0.1);
      justify-content: center;
      border-radius: 50%;
    }

    .text {
      width: 85%;
      text-align: start;
    }
  }

  .text-input {
    width: 100%;
    resize: none;
  }
  textarea {
    height: 200px; !important
  }
`;

const STATE = {
  isOpenAddModal: false,
  testDriveRemarks: [],
  newRemarkText: '',
  editableRemark: null,
};
/* eslint-disable react/prefer-stateless-function */
class VehicleTestDriveCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.vehicle?.testDriveRemarks &&
      this.setState({ testDriveRemarks: JSON.parse(this.props.vehicle?.testDriveRemarks) });
    this.props.vehicle?.test_drive_date_time &&
      this.setState({ test_drive_date_time: this.props.vehicle?.test_drive_date_time });
    this.props.fetch();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.test_drive_date_time !== this.state.test_drive_date_time) {
    }
  }

  get remarkDate() {
    return dayjs(new Date(Date.now())).format('DD-MM-YYYY HH:mm');
  }
  get sortingDate() {
    return new Date(Date.now());
  }

  renderInitials(name, surname) {
    return (
      <HBox left vCenter>
        <HBox className="initials-wrapper" vCenter left>
          <strong>{name[0]?.toUpperCase()}</strong>
          <strong>{surname[0]?.toUpperCase()}</strong>
        </HBox>
        &nbsp;
        <strong>{name ?? ''}</strong>
        &nbsp;
        <strong>{surname ?? ''}</strong>
      </HBox>
    );
  }

  datePicker(type) {
    let format = this.state[type]?.charAt?.(2) == '-' ? 'DD-MM-YYYY HH:mm' : undefined;

    let selected = this.state[type] && this.state[type] !== 'null' && dayjs(this.state[type], format);

    return (
      <div className={cn('d-flex align-items-baseline', styles.containerDatePicker)}>
        <DatePicker
          className={styles.datePicker}
          showTimeInput
          // dateFormat="dd-MM-yyyy"
          dateFormat="dd-MM-yyyy HH:mm"
          timeFormat="HH:mm"
          selected={selected && selected != 'Invalid Date' && selected.toDate()}
          onChange={date => {
            if (!date) return;
            let d = dayjs(date).format('DD-MM-YYYY HH:mm');
            this.setState({ [type]: d, showEditDate: true });
          }}
        />
        <Calendar className={styles.iconCalendar} />

        <HBox gap={'4px'} vCenter>
          <ButtonComponent
            style={'ButtonSoftEdit'}
            size={'btn-sm'}
            disabled={!this.state.showEditDate}
            onClick={() => {
              this.props.setDate(this.state.test_drive_date_time);
              this.setState({ showEditDate: false });
            }}
          >
            <Check />
          </ButtonComponent>
          <ButtonComponent
            style={'ButtonSoftDelete'}
            onClick={() => {
              this.props.deleteProperty(result => {
                console.log(result, 'RESULT');
                this.setState({ test_drive_date_time: null });
              });
            }}
          >
            <CircleTimes />
          </ButtonComponent>
        </HBox>
      </div>
    );
  }

  reset() {
    this.setState({ isOpenAddModal: false, newRemarkText: '', editableRemark: null });
  }

  onSave() {
    const remark = {
      id: Date.now(),
      text: this.state.newRemarkText,
      name: getPropByName(this.props.loggedUser, 'name'),
      surname: getPropByName(this.props.loggedUser, 'surname'),
      date: this.remarkDate,
      sortingDate: this.sortingDate,
    };

    const testDriveRemarks = [...this.state.testDriveRemarks, remark];

    this.props.setRemark(JSON.stringify(testDriveRemarks), result => {
      if (result) {
        this.reset();
      }
    });
  }

  onEdit(remarkId) {
    const remark = {
      id: remarkId,
      text: this.state.newRemarkText,
      name: getPropByName(this.props.loggedUser, 'name'),
      surname: getPropByName(this.props.loggedUser, 'surname'),
      date: this.remarkDate,
      sortingDate: this.sortingDate,
    };

    const testDriveRemarks = this.state.testDriveRemarks?.filter(remark => remark?.id != remarkId);
    const updatedRemarks = [...testDriveRemarks, remark];

    this.props.setRemark(JSON.stringify(updatedRemarks));
  }

  onDelete(remarkId) {
    const testDriveRemarks = this.state.testDriveRemarks?.filter(remark => remark?.id != remarkId);

    this.props.setRemark(JSON.stringify(testDriveRemarks));
  }

  renderAddModal() {
    return (
      <ModalComponent
        title={this.state.editableRemark ? this.lbl('info.remarks.edit') : this.lbl('info.remarks.add_testdrive')}
        onClose={this.reset.bind(this)}
      >
        <Textarea
          className="text-input"
          value={this.state.newRemarkText}
          onChange={e => this.setState({ newRemarkText: e.target?.value })}
        />

        <div className="d-flex gap-2 mt-2 justify-content-center">
          <ButtonComponent
            style={'ButtonSoftEdit'}
            disabled={this.props.work}
            onClick={this.state.editableRemark ? () => this.onEdit(this.state.editableRemark) : this.onSave.bind(this)}
          >
            {this.state.editableRemark ? this.lbl('confirm') : this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  render() {
    if (this.props.work) return <LoadingDetailsPageCard />;
    const nl2br = text => {
      return { __html: text?.replace(/(?:\r\n|\r|\n)/g, '<br>') };
    };
    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        <Container>
          {this.state.isOpenAddModal && this.renderAddModal(this.state.isEdit)}
          <HBox>
            <h2 className="card-title mb-0 text-muted">{this.lbl('info.remarks.test_drive')}</h2>
            <ButtonComponent
              style={'ButtonSoftPrimary'}
              size={'btn-sm'}
              onClick={() => this.setState({ isOpenAddModal: true })}
            >
              {this.lbl('info.remarks.add')}
            </ButtonComponent>
          </HBox>
          <List>
            {this.state.testDriveRemarks
              ?.sort((a, b) => ((b?.sortingDate ?? b.date) < (a?.sortingDate ?? a.date) ? -1 : 1))
              ?.map(remark => (
                <Row key={remark?.id}>
                  <div className={styles.remarkCard}>
                    <HBox className="gap-2" vCenter right>
                      <ButtonComponent
                        style="ButtonSoftEdit"
                        size="btn-sm"
                        onClick={() =>
                          this.setState({ isOpenAddModal: true, editableRemark: remark?.id, newRemarkText: remark?.text })
                        }
                      >
                        <Edit />
                      </ButtonComponent>
                      <ButtonComponent style="ButtonSoftDelete" size="btn-sm" onClick={() => this.onDelete(remark?.id)}>
                        <Trash />
                      </ButtonComponent>
                    </HBox>
                    <VBox className="remark" vCenter>
                      {remark?.name && remark?.surname && this.renderInitials(remark?.name, remark?.surname)}
                      <div className={styles.remarkText}>
                        <h6>{remark?.text}</h6>
                      </div>
                    </VBox>
                    <HBox right>{remark?.date}</HBox>
                  </div>
                </Row>
              ))}
          </List>
          <VBox style={{ padding: '14px 0' }}>
            <label className="form-label">{this.lbl('vehicle.property.testdrive.test_drive_date_time')}</label>
            {this.datePicker('test_drive_date_time')}
          </VBox>
        </Container>
      </Card>
    );
  }
}

VehicleTestDriveCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      REQUEST_USER,
      `${REQUEST_VEHICLE_PROPERTY_UPDATE}-testDriveRemarks`,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
      REQUEST_VEHICLE_PROPERTY_DELETE,
    ]),
    loggedUser: selectUser(ownProps?.loggedUserId),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchUser(ownProps?.loggedUserId));
    },
    setRemark(dto, callback) {
      dispatch(setVehicleProperty(ownProps?.vehicle?.id, 'testDriveRemarks', dto, callback));
    },
    setDate(date, callback) {
      dispatch(setVehicleProperty(ownProps.vehicle?.id, 'test_drive_date_time', date, callback));
    },
    deleteProperty(callback) {
      dispatch(deleteVehicleProperty(ownProps.vehicle?.id, 'test_drive_date_time', callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleTestDriveCard = compose(withConnect, withRouter)(VehicleTestDriveCardComp);
